export function renderShareMenu() {
  //generate the mailto link.
  //Get the title -- most probably the H1 of the page.
  const pageTitle = document.querySelectorAll("h1")[0]?.textContent ?? "";
  const URLencodedpageTitle = encodeURI(pageTitle);
  //Get the current location
  const currentURL = document.location.href;
  const mailToLink = `mailto:?subject=Learn%20more%20about%20${URLencodedpageTitle}&body=${currentURL}`;
 
  //LinkedInLink
  const linkedInLink = `https://www.linkedin.com/cws/share?url=${currentURL}`;
  //TwitterLink
  const twitterLink = `https://twitter.com/intent/tweet?text=${URLencodedpageTitle}&url=${currentURL}`;
  const facebookLink = `https://www.facebook.com/sharer.php?u=${currentURL}`;
 
    return `<div class="text-hero__share-widget no-print d-none">
    <div
      class="share-widget widget dropdown ignore-placement-fix"
      id="share-widget-popover-content"
    >
      <div
        role="menu"
        class="share-widget__menu widget-menu dropdown-menu focusable-menu widget-menu-left"
        aria-labelledby="share-widget-button"
      >
        <div class="share-widget__menu-inner">
                    <ul class="mb-0 list-unstyled">
                    <li class="mb-0 text-util-md share-menu-header">
              <div
                class="share-widget__action share-Link">
                <span class="share-widget__text">Share Page</span>
                <span class="sr-only">
                  This link opens in a new window.
                </span>
              </div>
            </li>
            <li class="mb-0 text-util-md">
              
                id="linkedin"
                role="menuitem"
                class="share-widget__action share-Link"
                href='${linkedInLink}'
                rel="noreferrer noopener"
                target="_blank"
              >
                ${getSVG("linkedin")}
                <span class="share-widget__text">LinkedIn</span>
                <span class="sr-only">
                  This link opens in a new window.
                </span>
              </a>
            </li>
            <li class="mb-0 text-util-md">
              
                id="twitter"
                role="menuitem"
                data-text="${pageTitle}"
                data-author=""
                class="share-widget__action share-Link"
                href='${twitterLink}'
                rel="noreferrer noopener"
                target="_blank"
              >
                ${getSVG("twitter")}
                <span class="share-widget__text">X</span>
                <span class="sr-only">
                  This link opens in a new window.
                </span>
              </a>
            </li>
            <li class="mb-0 text-util-md">
              
                class="share-widget__action share-Link"
                href='${facebookLink}'
                id="facebook"
                role="menuitem"
                rel="noreferrer noopener"
                target="_blank"
              >
                ${getSVG("facebook")}
                <span class="share-widget__text">Facebook</span>
                <span class="sr-only">
                  This link opens in a new window.
                </span>
              </a>
            </li>
            <li class="mb-0 text-util-md">
              
                class="share-widget__action share-Link"
                href='${mailToLink}'
                id="email-link"
                role="menuitem"
                target="_blank"
                rel="nofollow"
              >
                ${getSVG("email")}
                <span class="share-widget__text">Email</span>
                <span class="sr-only">
                  This link opens in a new window.
                </span>
              </a>
            </li>
            <li class="mb-0 text-util-md portfolio-page-d-none">
              <button
                class="share-widget__action mb-0 text-util-md print"
                onlcick='(e) => window.print()'
                type="button"
                role="menuitem"
                            >
                                ${getSVG("print")}
                <span class="share-widget__text">Print</span>
                <span class="sr-only">
                  This link opens in a new window.
                </span>
              </button>
            </li>
          </ul>
        </div> 
      </div>
      <span class="share-widget__overlay"></span>
    </div>
  </div>`;    
 
 }
 
 /**
 * Get's the svg based on the SVG name.
 * @param {string} name
 * @returns
 */
 export function getSVG(name) {
    let markup = "";
    switch (name) {
        case "linkedin":
            markup = `<svg aria-labelledby="svg-inline--fa-title-linkedin-sharemenu" data-prefix="fab" data-icon="linkedin-in" class="svg-inline--fa fa-linkedin-in fa-w-16 fa-lg icon" style="width: 25px; height:25px; margin-right: 0.75rem" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <title id="svg-inline--fa-title-linkedin-sharemenu">LinkedIn</title>
            <path d="M5.5,1h9A4.49,4.49,0,0,1,19,5.5v9A4.49,4.49,0,0,1,14.5,19h-9A4.49,4.49,0,0,1,1,14.5v-9A4.49,4.49,0,0,1,5.5,1Zm.62,8.1v5.4m3.6,0V11.35A2.25,2.25,0,0,1,12,9.1h0a2.25,2.25,0,0,1,2.25,2.25V14.5M6.12,5.84a.23.23,0,1,0,.22.22.22.22,0,0,0-.22-.22" fill="none" stroke="#17468f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>`;
            break;
        case "facebook":
            markup = `<svg aria-labelledby="svg-inline--fa-title-facebook-sharemenu" data-prefix="fab" data-icon="-in" class="svg-inline--fa fa--in fa-w-16 fa-lg icon" style="width: 25px; height:25px; margin-right: 0.75rem" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <title id="svg-inline--fa-title-facebook-sharemenu">Facebook</title>
            <path d="M5.5,1h9A4.49,4.49,0,0,1,19,5.5v9A4.49,4.49,0,0,1,14.5,19h-9A4.49,4.49,0,0,1,1,14.5v-9A4.49,4.49,0,0,1,5.5,1Zm3.6,9.9h5.4m0-4.5h-.95A2.65,2.65,0,0,0,10.9,9.05V19" fill="none" stroke="#17468f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>`;
            break;
        case "twitter":
            markup = `<svg aria-labelledby="svg-inline--fa-title-twitter-sharemenu" data-prefix="fab" data-icon="twitter-in" class="svg-inline--fa fa-twitter-in fa-w-16 fa-lg icon" style="width: 25px; height:25px; margin-right: 0.75rem" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 -5 53 53">
            <title id="svg-inline--fa-title-twitter-sharemenu">X</title>
            <path fill="#17468f" stroke="#17468f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m36.53,50H13.47C6.04,50,0,43.96,0,36.53V13.48C0,6.05,6.05,0,13.48,0h23.05C43.96,0,50,6.04,50,13.47v23.06c0,7.43-6.04,13.47-13.47,13.47ZM13.48,3.92c-5.27,0-9.56,4.29-9.56,9.56v23.05c0,5.27,4.28,9.55,9.55,9.55h23.06c5.27,0,9.55-4.28,9.55-9.55V13.47c0-5.26-4.28-9.55-9.55-9.55H13.48Z"/>
            <path fill="#17468f" stroke="#17468f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="m28.95,22.62l12.09-13.06h-4.75l-9.46,10.22-7.65-10.22H7.99l12.65,16.91-12.94,13.97h4.75l10.31-11.14,8.33,11.14h11.19l-13.33-17.82Zm-11.52-9.57l17.87,23.89h-2.46L14.97,13.05h2.46Z"/>
            </svg>`;
            break;
        case "print":
            markup = `<svg aria-labelledby="svg-inline--fa-title-print-sharemenu" data-prefix="fab" data-icon="print-in" class="svg-inline--fa fa-print-in fa-w-16 fa-lg icon" style="width: 25px; height:25px; margin-right: 0.75rem" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <title id="svg-inline--fa-title-print-sharemenu">Print</title>
            <path d="M5.13,6V2a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V6m-10,9h-2a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2h14a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2h-2m-10-3.2h10V18a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1V11.8Zm0-2.8h1" fill="none" stroke="#17468f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>`;
            break;
        case "email":
            markup = `<svg aria-labelledby="svg-inline--fa-title-email-sharemenu" data-prefix="fab" data-icon="email-in" class="svg-inline--fa fa-email-in fa-w-16 fa-lg icon" style="width: 25px; height:25px; margin-right: 0.75rem" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <title id="svg-inline--fa-title-email-sharemenu">Email</title>
            <path d="M17,17H3a2,2,0,0,1-2-2V5A2,2,0,0,1,3,3H17a2,2,0,0,1,2,2V15a2,2,0,0,1-2,2ZM16,6l-6,4L4,6" fill="none" stroke="#17468f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>`;
    }
 
    return markup;
 }